import { AdUnit } from "../../AdUnit.js";
import { AdCallParams } from "../../AdCallParams.js";
import { AdCallParamsFilter } from "../ComposableResolver.js";
import { VideoInfoRawData } from "../../../../model/video/VideoInfo.js";

export function getTestCallFilter(enable: boolean): AdCallParamsFilter  {

    return function (unit: AdUnit,info: VideoInfoRawData, params: AdCallParams): AdCallParams {
        const useParams: AdCallParams = params?params:{};
        useParams.custom_params = useParams.custom_params?useParams.custom_params:{};
        if(enable) useParams.custom_params.fptst = 1;
        return useParams;
    }
}